const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_settingsLayout/settings/plans/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { planIntervals } from "@circle-react/helpers/plansHelpers";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
const plansSearchSchema = z.object({
  billing_cycle: z.enum([planIntervals.month, planIntervals.year]).optional().catch(undefined),
  billing_currency: z.string().optional().catch(undefined),
  sales_utm_campaign: z.string().optional().catch(undefined)
});
export const Route = createFileRoute("/_protected/_settingsLayout/settings/plans/")({
  validateSearch: plansSearchSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});